import React, { Component } from 'react'
import { Button, Modal, Form, Select, Spin, Dropdown } from 'antd'
import {Link} from 'dva/router'
import config from '../../utils/config'
import { connect } from 'dva'
import { all, get } from '../../services/restApi'
var Icon = require('react-fontawesome')
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;

class Header extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            modalVisible: false,
            hotels: [],
        }
    }

    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        let query = {type: 'tours'};

        if (this.props.user.type === 'recepcionista' || this.props.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.user.companies, 'objectId')};
        }

        // Consulta los hoteles
        all('TourCompany', {
            where: query,
            limit: 20
        }).then((resp) => {

            resp.results.unshift({
                objectId: 'todos',
                name: 'Todos'
            });

            this.props.dispatch({type:'app/setCurrentHotelSuccess', 
                payload: { currentHotel: {} }
            });

            this.setState({
                hotels: resp.results
            });

            if (this.props.currentHotel.objectId) this.props.form.setFieldsValue({hotel: {key: this.props.currentHotel.objectId, label: this.props.currentHotel.name}});
        })
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel');
        } else {
            this.setState({loading: true});

            if (value.key === 'todos') {
                this.props.dispatch({type:'app/setCurrentHotelSuccess', 
                    payload: { currentHotel: {} }
                });

                window.location.reload();

            } else {
                get('TourCompany', value.key).then((resp) => {
                    this.props.dispatch({type:'app/setCurrentHotelSuccess', 
                        payload: { currentHotel: resp }
                    });

                    window.location.reload();
                });
            }

            callback();
        }
    }


    showModal () { this.setState({ modalVisible: true }); }
    hideModal () { this.setState({ modalVisible: false }); }
        
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <header className="main-header">

                <a href="/dashboard" className="logo">
                    <span className="logo-mini">CRM</span>
                    <div className="logo-lg" style={{ 
                        backgroundImage: this.props.currentHotel.picture ? 'url(' + config.externalUrl + 'uploads/hotels/' + this.props.currentHotel.picture + ')' : 'url(assets/img/logo.png)',
                    }}>
                    </div>
                </a>
                <div className="pleca-logo" style={{backgroundColor: this.props.currentHotel && this.props.currentHotel.color ? this.props.currentHotel.color : config.color}}></div>

                <nav className="navbar navbar-static-top navbar-top" style={{background: 'transparent'}}>
                    {/*<div className="navbar-left">
                        <ul className="nav navbar-nav nav-top">
                            <li className="dropdown tasks-menu">
                                <a onClick={ this.showModal.bind(this) } className="dropdown-toggle" data-toggle="dropdown">
                                    <Icon name="cog" /> Cambiar Hotel
                                </a>
                            </li>
                        </ul>
                    </div>*/}

                    <div className="navbar-custom-menu">
                        <ul className="nav navbar-nav nav-top">
                            <li className="dropdown tasks-menu">
                                <Dropdown overlay={
                                    <div className="app-menu row">
                                        <div className="col-md-12 text-center text-bold app-menu-title">
                                            CRM's
                                        </div>
                                        <div className="col-md-4 item-menu text-center nopadding">
                                            <a href="https://factura.triehotels.com/" target="_blank" style={{color: '#D10810'}}>
                                                <Icon name="hotel" /><br />
                                                <small>Hotel</small>
                                            </a>
                                        </div>
                                        <div className="col-md-4 item-menu text-center nopadding">
                                            <a href="/" style={{color: '#F3B633'}}>
                                                <Icon name="swimmer" /><br />
                                                <small>Tours</small>
                                            </a>
                                        </div>
                                        <div className="col-md-4 item-menu text-center nopadding">
                                            <a href="https://restaurante.triehotels.com/" target="_blank" style={{color: '#7ACBD3'}}>
                                                <Icon name="utensils" /><br />
                                                <small>Restaurante</small>
                                            </a>
                                        </div>
                                    </div>
                                }>
                                    <a  className="dropdown-toggle" data-toggle="dropdown">
                                        <i className="fa fa-th"></i>
                                    </a>
                                </Dropdown>
                            </li>

                            <li className="btn-exit">
                                <a onClick={this.props.logout} href=""><i className="fa fa-sign-out-alt"></i><br />Salir</a>
                            </li>
                        </ul>
                    </div>
                </nav>

                <nav className="navbar navbar-static-top navbar-down" style={{backgroundColor: this.props.currentHotel && this.props.currentHotel.color ? this.props.currentHotel.color : config.color}}>
                    <a  className="sidebar-toggle fa" data-toggle="offcanvas"  onClick={this.props.toggleMenu} style={{height: '45px'}}>
                        <span className="sr-only">Toggle navigation</span>
                    </a>

                    <div className="navbar-custom-menu">
                        <ul className="nav navbar-nav">
                            <li className="dropdown tasks-menu">
                                <Dropdown overlay={
                                    <div className="app-menu row">
                                        <div className="col-md-12 text-center text-bold app-menu-title">
                                            CRM's
                                        </div>
                                        <div className="col-md-4 item-menu text-center nopadding">
                                            <a href="https://factura.triehotels.com/" target="_blank" style={{color: '#D10810'}}>
                                                <Icon name="hotel" /><br />
                                                <small>Hotel</small>
                                            </a>
                                        </div>
                                        <div className="col-md-4 item-menu text-center nopadding">
                                            <a href="/" style={{color: '#F3B633'}}>
                                                <Icon name="swimmer" /><br />
                                                <small>Tours</small>
                                            </a>
                                        </div>
                                        <div className="col-md-4 item-menu text-center nopadding">
                                            <a href="https://restaurante.triehotels.com/" target="_blank" style={{color: '#7ACBD3'}}>
                                                <Icon name="utensils" /><br />
                                                <small>Restaurante</small>
                                            </a>
                                        </div>
                                    </div>
                                }>
                                    <a  className="dropdown-toggle" data-toggle="dropdown">
                                        <i className="fa fa-th"></i>
                                    </a>
                                </Dropdown>
                            </li>
                            
                            <li className="dropdown user-display">
                                <span className="hidden-xs ng-binding">
                                    {this.props.user.name}<br />
                                    {this.props.user.type}
                                </span>
                            </li>

                            <li className="logo-user">
                                {!this.props.user.picture
                                    ? <img className="img-circle user-image profile-user-img" alt="User Profile" src="assets/img/noimage.png" />
                                    : <img className="img-circle user-image profile-user-img" alt="User Profile" src={config.externalUrl + 'uploads/users/' + this.props.user.picture} />
                                }
                            </li>

                            <li className={'dropdown user user-menu ' + (this.props.userMenuVisible ? 'open' : '')}>
                                <a  className="dropdown-toggle" data-toggle="dropdown" onMouseEnter={this.props.toggleUserMenu} onMouseLeave={this.props.toggleUserMenu}>
                                    <i className="fa fa-user"></i>
                                </a>

                                <ul className="dropdown-menu" onMouseEnter={this.props.toggleUserMenu} onMouseLeave={this.props.toggleUserMenu}>
                                    <li className="user-header" style={{backgroundColor: this.props.currentHotel && this.props.currentHotel.color ? this.props.currentHotel.color : config.color}}>
                                        {!this.props.user.picture
                                            ? <img src="assets/img/noimage.png" className="img-circle" alt="User" />
                                            : <img src={config.externalUrl + 'uploads/users/' + this.props.user.picture} className="img-circle" alt="User" />
                                        }
                                        <p>
                                            {this.props.user.name}<br />
                                            {this.props.user.type}
                                        </p>
                                    </li>
                                    
                                    <li className="user-footer">
                                        <div className="pull-left">
                                            <Button type="primary" className="btn btn-flat">
                                                <Link to="/profile"><i className="fa fa-user"></i> Perfil</Link>
                                            </Button>
                                        </div>
                                        <div className="pull-right">
                                            <Button type="danger" className="btn btn-flat" onClick={this.props.logout}><i className="fa fa-sign-out-alt"></i> Salir</Button>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>

                <Modal
                    width={300}
                    visible={this.state.modalVisible}
                    title="Configuración"
                    onCancel={ this.hideModal.bind(this) }
                    footer={[]} 
                >
                    <Spin tip='Cargando...' spinning={this.state.loading} size='large'>
                        <Form>
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    {this.props.currentHotel.picture
                                        ? <img src={config.externalUrl + 'uploads/hotels/' + this.props.currentHotel.picture} style={{width: '80%'}} />
                                        : ''
                                    }

                                    <p style={{marginTop: '20px', marginBottom: '15px'}}>El sistema devolverá registros correspondientes al Hotel elegido.</p>

                                    <FormItem label="Elija el hotel">
                                        {this.props.form.getFieldDecorator('hotel', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija el hotel',
                                            }, {
                                                validator: this.checkHotel.bind(this)
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                mode="combobox"
                                                onChange={this.handleSelectHotelChange.bind(this)}
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                placeholder="Elija el hotel"
                                                >
                                                {hotel_options}
                                            </Select>
                                        )}
                                    </FormItem>
                                </div>
                            </div>
                        </Form>
                    </Spin>
                </Modal>
            </header>   
        )
    }
}

//export default Header
export default connect(({}) => ({}))(Form.create()(Header))


// WEBPACK FOOTER //
// ./src/components/layout/header.js